<template>
  <section>
    <z-dialog :show="isVisible">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
            <div class="custom-subtitle">{{ subtitle }}</div>
          </div>
          <div class="col-1 custom-close-wrapper">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <!-- makeExceptions -->
          <div class="row">
            <div class="col">
              <div v-if="!loading.makeExceptions" class="input-group">
                <span class="input-group-text">Attribute:</span>
                <select v-if="!isEditing.attribute" v-model="attributeExclusion" class="form-control">
                  <option v-for="(item, idx) in attributes" :key="idx" :value="item">{{ item }}</option>
                </select>
                <input v-if="isEditing.attribute" v-model="attributeExclusion" class="form-control" type="text" placeholder="enter attribute" />
                <button
                  v-if="!isEditing.attribute"
                  class="btn btn-info custom-focus"
                  type="button"
                  title="edit attribute"
                  tabindex="-1"
                  @click="edit('attribute')"
                >
                  <i class="far fa-edit"></i>
                </button>
                <button
                  v-if="isEditing.attribute"
                  class="btn btn-warning custom-focus"
                  type="button"
                  title="edit attribute"
                  tabindex="-1"
                  @click="cancel('attribute')"
                >
                  <i class="fas fa-ban"></i>
                </button>
              </div>
              <div v-else>
                <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div v-if="!loading.makeExceptions" class="input-group">
                <span class="input-group-text">Item:</span>
                <select v-if="!isEditing.item" v-model="itemExclusion" name="itemExclusion" class="form-control">
                  <option v-for="(item, idx) in items" :key="idx" :value="item">{{ item }}</option>
                </select>
                <input v-if="isEditing.item" v-model="itemExclusion" class="form-control" type="text" placeholder="enter item" />
                <button v-if="!isEditing.item" class="btn btn-info custom-focus" type="button" title="edit item" tabindex="-1" @click="edit('item')">
                  <i class="far fa-edit"></i>
                </button>
                <button
                  v-if="isEditing.item"
                  class="btn btn-warning custom-focus"
                  type="button"
                  title="edit item"
                  tabindex="-1"
                  @click="cancel('item')"
                >
                  <i class="fas fa-ban"></i>
                </button>
              </div>
              <div v-else>
                <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div v-if="!loading.makeExceptions" class="input-group">
                <span class="input-group-text">Location:</span>
                <select v-if="!isEditing.location" v-model="locationExclusion" class="form-control">
                  <option v-for="(item, idx) in locations" :key="idx" :value="item">{{ item }}</option>
                </select>
                <input v-if="isEditing.location" v-model="locationExclusion" class="form-control" type="text" placeholder="enter location" />
                <button
                  v-if="!isEditing.location"
                  class="btn btn-info custom-focus"
                  type="button"
                  title="edit location"
                  tabindex="-1"
                  @click="edit('location')"
                >
                  <i class="far fa-edit"></i>
                </button>
                <button
                  v-if="isEditing.location"
                  class="btn btn-warning custom-focus"
                  type="button"
                  title="edit location"
                  tabindex="-1"
                  @click="cancel('location')"
                >
                  <i class="fas fa-ban"></i>
                </button>
              </div>
              <div v-else>
                <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div v-if="!loading.makeExceptions" class="input-group">
                <span class="input-group-text">Value:</span>
                <select v-if="!isEditing.value" v-model="valueExclusion" class="form-control">
                  <option v-for="(item, idx) in values" :key="idx" :value="item">{{ item }}</option>
                </select>
                <input v-if="isEditing.value" v-model="valueExclusion" class="form-control" type="text" placeholder="enter value" />
                <button
                  v-if="!isEditing.value"
                  class="btn btn-info custom-focus"
                  type="button"
                  title="edit value"
                  tabindex="-1"
                  @click="edit('value')"
                >
                  <i class="far fa-edit"></i>
                </button>
                <button
                  v-if="isEditing.value"
                  class="btn btn-warning custom-focus"
                  type="button"
                  title="edit value"
                  tabindex="-1"
                  @click="cancel('value')"
                >
                  <i class="fas fa-ban"></i>
                </button>
              </div>
              <div v-else>
                <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="row custom-footer">
          <div class="col-1">
            {{ id }}
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button type="button" class="btn btn-primary" :class="{ 'btn-danger': isSave }" @click="save">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
export default {
  name: 'DialogExclusionMake',
  components: {
    ZDialog,
    ZMessage,
    FontAwesomeIcon
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lg',
      message: '',
      isSave: false,
      isEditing: {
        attribute: false,
        item: false,
        location: false,
        value: false
      }
    }
  },
  emits: ['input', 'closing', 'saved'],
  watch: {
    makeException() {
      let found = null
      this.isEditing = {
        attribute: false,
        item: false,
        location: false,
        value: false
      }
      if (this.makeException.attribute) {
        found = this.attributes.find((x) => x.trim().toUpperCase() === this.makeException.attribute.trim().toUpperCase())
        if (!found) {
          this.isEditing.attribute = true
        }
      }
      if (this.makeException.location) {
        found = this.locations.find((x) => x.trim().toUpperCase() === this.makeException.location.trim().toUpperCase())
        if (!found) {
          this.isEditing.location = true
        }
      }
      if (this.makeException.item) {
        found = this.items.find((x) => x.trim().toUpperCase() === this.makeException.item.trim().toUpperCase())
        if (!found) {
          this.isEditing.item = true
        }
      }
      if (this.makeException.value) {
        found = this.values.find((x) => x.trim().toUpperCase() === this.makeException.value.trim().toUpperCase())
        if (!found) {
          this.isEditing.value = true
        }
      }
    }
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'makeExceptionLookups', 'makeException']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = ''
      if (this.modelValue) {
        if (this.modelValue.type === 'ADD') {
          _title = 'Add Category Y/M/M Exclusion'
        } else {
          _title = 'Editing Category Y/M/M Exclusion'
        }
      }
      return _title
    },
    subtitle() {
      let _subtitle = ''
      if (this.makeException) {
        if (this.modelValue.vehicle) {
          _subtitle = this.modelValue.vehicle
        }
      }
      return _subtitle
    },
    id() {
      let _id = null
      if (this.value !== undefined && this.value !== null) {
        _id = this.modelValue.adasChecklistExclusionMake
      }
      return _id
    },
    notice() {
      let _notice = ''
      if (this.value !== undefined && this.value !== null) {
        if (this.modelValue.type === 'ADD') {
          _notice =
            "You're about to add a new ADAS Category Y/M/M exclusion. Setting the following Exclusion, will exclude those items matching what was decoded."
        } else {
          _notice = "You're editing this ADAS Category Y/M/M exclusion."
        }
      }
      return _notice
    },
    attributes() {
      let _data = []
      if (this.makeExceptionLookups) {
        _data = this.getUniqueValues(
          this.makeExceptionLookups.map((x) => x.attribute),
          false
        )
      }
      console.log('attributes', _data)
      return _data
    },
    items() {
      let _data = []
      if (this.makeExceptionLookups) {
        _data = this.getUniqueValues(
          this.makeExceptionLookups.map((x) => x.item),
          false
        )
      }
      return _data
    },
    locations() {
      let _data = []
      if (this.makeExceptionLookups) {
        _data = this.getUniqueValues(
          this.makeExceptionLookups.map((x) => x.location),
          true
        )
      }
      return _data
    },
    values() {
      let _data = []
      if (this.makeExceptionLookups) {
        _data = this.getUniqueValues(
          this.makeExceptionLookups.map((x) => x.value),
          true
        )
      }
      return _data
    },
    itemExclusion: {
      get() {
        let _item = ''
        if (this.makeException) {
          _item = this.makeException.item
        }
        return _item
      },
      set(value) {
        this.setException({
          name: 'item',
          value: value
        })
        this.isSave = true
      }
    },
    attributeExclusion: {
      get() {
        let _attribute = ''
        if (this.makeException) {
          _attribute = this.makeException.attribute
        }
        return _attribute
      },
      set(value) {
        this.setException({
          name: 'attribute',
          value: value
        })
        this.isSave = true
      }
    },
    locationExclusion: {
      get() {
        let _location = ''
        if (this.makeException) {
          _location = this.makeException.location
        }
        return _location
      },
      set(value) {
        this.setException({
          name: 'location',
          value: value
        })
        this.isSave = true
      }
    },
    valueExclusion: {
      get() {
        let _value = ''
        if (this.makeException) {
          _value = this.makeException.value
        }
        return _value
      },
      set(value) {
        this.setException({
          name: 'value',
          value: value
        })
        this.isSave = true
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['setException', 'saveMakeException']),
    close() {
      this.$emit('closing')
    },
    getUniqueValues(array, addBlank) {
      if (addBlank) {
        return [''].concat([...new Set(array.filter((x) => x !== null && x.trim() !== ''))])
      } else {
        return [...new Set(array.filter((x) => x !== null && x.trim() !== ''))]
      }
    },
    edit(name) {
      this.isEditing[name] = !this.isEditing[name]
    },
    cancel(name) {
      this.isEditing[name] = false
    },
    async save() {
      this.message = ''
      let proceed = true
      if (this.makeException.item === null || this.makeException.item === '') {
        proceed = false
      }
      if (proceed) {
        let data = {
          adasChecklistExclusionMake: this.makeException.adasChecklistExclusionMake,
          adasChecklistMatrixVehicle: this.makeException.adasChecklistMatrixVehicle,
          item: this.makeException.item,
          attribute: this.makeException.attribute,
          location: this.makeException.location,
          value: this.makeException.value
        }
        console.log('saving ADAS Make Exclusion', data)
        await this.saveMakeException(data)
        this.isSave = false
        this.isEditing = {
          attribute: false,
          item: false,
          location: false,
          value: false
        }
        this.$emit('saved')
      } else {
        this.message = 'Please provide an Item Exclusion.'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close-wrapper {
  position: relative;
  text-align: right;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-textarea {
  height: 200px;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
.custom-subtitle {
  font-size: 0.8em;
  font-weight: 500;
}
.custom-focus:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
  border: transparent;
}
</style>
